/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import React from "react";
import { formatNumber } from "utils/formatNumber";

export default function OrdersModal({ show, onClose, orders, openOrderDetails, theme }) {
  if (!show) return null;

  // دالة لحساب الإجمالي من تفاصيل الطلب إذا كان netAmount صفراً
  const calculateTotal = (order) => {
    if (order.netAmount > 0) return order.netAmount;

    // جمع الـ lineTotal لكل عنصر داخل تفاصيل الطلب
    return order.details?.reduce((sum, item) => sum + (item.lineTotal || 0), 0) || 0;
  };

  return (
    <div style={{ ...overlay, alignItems: "stretch", padding: 0 }}>
      <div style={{
        ...modal,
        width: "100vw",
        maxWidth: "100vw",
        height: "100vh",
        maxHeight: "100vh",
        borderRadius: 0,
        overflowY: "auto"
      }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
          <h3 style={{ margin: 0 }}>طلباتي</h3>
          <button onClick={onClose} style={btnClose}>إغلاق</button>
        </div>

        {orders.filter(order => order.orderNo && order.city).length === 0 ? (
          <p style={{ textAlign: "center" }}>لا يوجد طلبات مؤكدة بعد.</p>
        ) : orders.filter(order => order.orderNo).map(order => (
          <div key={`${order.orderId}-${order.orderNo}`} style={card}>
            <div>
              <strong style={{ display: "block", marginBottom: 4 }}>
                رقم الطلب: #{order.orderNo || "-"}
              </strong>
              <p style={{ margin: "2px 0", fontSize: "14px", color: "#666" }}>
                الحالة: <span style={{ color: theme.primary }}>{order.status}</span>
              </p>
              <p style={{ margin: "2px 0", fontWeight: "bold" }}>
                الإجمالي: {formatNumber(calculateTotal(order))} IQD
              </p>
            </div>

            <button
              style={{
                background: theme.primary,
                color: "#fff",
                border: "none",
                borderRadius: 8,
                padding: "8px 14px",
                cursor: "pointer"
              }}
              onClick={() => openOrderDetails(order)}
            >
              عرض التفاصيل
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

const overlay = { position: "fixed", inset: 0, background: "rgba(0,0,0,.6)", zIndex: 20000, display: "flex", justifyContent: "center", alignItems: "center" };
const modal = { background: "#fff", width: "100%", maxWidth: 700, padding: 25, borderRadius: 18, maxHeight: "80vh", overflowY: "auto" };
const card = { display: "flex", justifyContent: "space-between", alignItems: "center", border: "1px solid #eee", borderRadius: 12, padding: 15, marginBottom: 12 };
const btnClose = { background: "#f3f4f6", border: "1px solid #e5e7eb", borderRadius: 10, padding: "8px 14px", cursor: "pointer" };